function BookingDetailController() {
    this.constructor.apply(this, arguments);
}

BookingDetailController.$inject = ['$scope', '$state', 'VehicleBookingService', '$mdDialog', '$stateParams', '$message', '$Loading', '$translationService', 'DeviceService', 'AuthService', 'AttackmentService'];
BookingDetailController.prototype = {
    /**
     *
     * @param $scope {IScope}
     * @param $state {ui.IStateService}
     * @param VehicleBookingService {VehicleBookingService}
     * @param $mdDialog {$mdDialog}
     * @param $stateParams {ui.IStateParamsService}
     * @param $message {$message}
     * @param $Loading {$Loading}
     * @param $translationService {$translationService}
     * @param DeviceService {DeviceService}
     * @param AuthService {AuthService}
     * @param AttackmentService {AttackmentService}
     * @constructor
     */
    constructor($scope, $state, VehicleBookingService, $mdDialog, $stateParams, $message, $Loading, $translationService, DeviceService, AuthService, AttackmentService) {
        this.$scope = $scope;
        this.$state = $state;
        this.vehicleBookingService = VehicleBookingService;
        this.$mdDialog = $mdDialog;
        this.$stateParams = $stateParams;
        this.$message = $message;
        this.$Loading = $Loading;
        this.$translationService = $translationService;
        this.deviceService = DeviceService;
        this.attackmentService = AttackmentService;

        /*** @type IVehicleBooking  */
        this.item = this.$scope.item;


        /*** @type VehicleBookingAttachment[]  */
        this.attachments = this.attackmentService.getAttachmentFiles(this.item.Attachments);

    },


    goBack(){
        this.$scope.goBack();
    },

    /**
     * Remove a booking
     * @param {IVehicleBooking} booking
     * @returns {angular.IPromise<any>}
     */
    removeBooking(booking) {
        this.vehicleBookingService.removeBooking(booking.Id).then(() => {
            this.goBack();
        }, this.$message.error);
    },

    /**
     * Click on delete button to remove current booking
     * @param $event{MouseEvent}
     */
    onDeleteClicked($event) {
        let vehicleBooking = this.item;
        let confirm = this.$mdDialog.confirm()
            .theme('custom-confirm')
            .clickOutsideToClose(true)
            .title(this.$translationService.getTranslation('DeleteVehicleBooking'))
            .htmlContent(this.$translationService.getTranslation('ConfirmDeleteDeleteVehicleBooking') + ' <b>' + vehicleBooking.VehicleModel + '</b>')
            .targetEvent($event)
            .ok(this.$translationService.getTranslation('Yes'))
            .cancel(this.$translationService.getTranslation('No'));
        this.$mdDialog.show(confirm).then(() => {
            this.removeBooking(vehicleBooking);
        });
    },

    /**
     * Show no vehicle available modal
     * @param vehicleBooking {IVehicleBooking}
     * @param $event {MouseEvent}
     */
    showNoVecilesModal(vehicleBooking, $event) {
        let availableFrom = moment(vehicleBooking.StartDate).format('DD/MM/YYYY') + ' ' + vehicleBooking.StartTime;
        let availableTo = moment(vehicleBooking.EndDate).format('DD/MM/YYYY') + ' ' + vehicleBooking.EndTime;
        let confirm = this.$mdDialog.alert()
            .theme('custom-confirm')
            .clickOutsideToClose(true)
            .title(this.$translationService.getTranslation('NoOtherVehicleAvailable'))
            .htmlContent(this.$translationService.formatTranslation('NoVehicleAvailableInperiod', availableFrom, availableTo))
            .targetEvent($event)
            .ok(this.$translationService.getTranslation('OK'));
        this.$mdDialog.show(confirm);
    },

    /**
     *
     * @param vehicleBooking {IVehicleBooking}
     * @param options {Object}
     * @param $event {MouseEvent}
     */
    showChangeVehicleModel(vehicleBooking, options, $event) {
        this.$mdDialog.show({
            targetEvent: $event,
            templateUrl: 'js/internal/vehiclebookings/dialogs/change-vehicle/change-vehicle.html',
            controllerAs: 'vm',
            controller: 'ChangeVehicleDialogController',
            clickOutsideToClose: false,
            focusOnOpen: true,
            escapeToClose: false,
            locals: {
                vehicleBooking: vehicleBooking,
                options: options
            }
        }).then((data) => {
            if (data) {
                // Update param and reloead state
                let params = this.$stateParams;
                params.id = data.NewVehicleBookingId;
                this.$state.go("internal.booking-details", params,  {reload: true}); 
            }
        })
    },

    /**
     *
     * @param $event {MouseEvent}
     */
    onChangeVehicle($event) {
        let vehicleBooking = this.item;
        let availableFrom = moment(vehicleBooking.StartDate).format('YYYY-MM-DD') + 'T' + vehicleBooking.StartTime + ':00';
        let availableTo = moment(vehicleBooking.EndDate).format('YYYY-MM-DD') + 'T' + vehicleBooking.EndTime + ':00';
        this.vehicleBookingService.getVehiclesFromRange(availableFrom, availableTo, "", 0, 1)
            .finally(this.$Loading.blockUI())
            .then((result) => {
                if (result.TotalCount === 0) {
                    this.showNoVecilesModal(vehicleBooking, $event);
                } else {
                     let requestData= {
                        availableFrom:availableFrom,
                        availableTo: availableTo
                    }
                    this.showChangeVehicleModel(vehicleBooking, requestData, $event);
                }
            }, this.$message.error)
    }
}


angular.module('internal.vehiclebookings').directive('bookingDetail', function () {
    return {
        restrict: 'E',
        templateUrl: 'js/internal/vehiclebookings/directives/booking-detail/booking-detail.html',
        controllerAs: 'vm',
        replace: false,
        controller: BookingDetailController,
        scope: {
            item: '=',
            goBack: '&'
        },
    };
});